// Ids das situações do Chamado. As DESCRIÇÕES não moram mais aqui: vêm da tabela chamado_situacao
// (services/situacoes.js) desde 2026-09-18, para que inativar uma situação no cadastro não exija deploy do
// Portal nem do Raptor. O que fica aqui é o significado de negócio, que se escreve com id, igual ao Raptor.
// O 6 ("Baixado", só do Lizard) saiu em 31/10/2026 com o Lizard parado.
export const SituacaoChamado = {
  Em_Aberto: 1,
  Em_Analise: 2,
  Elaborando_Orcamento: 3, //Antigo Em Avaliação
  Aguardando_Aprovacao: 4, //Antigo Em Orçamento
  Em_Progresso: 5,
  Encerrado: 7,
  Cancelado: 8,
};

// Situação terminal: o chamado está fechado e não aceita ação nova pelo Portal. Espelha
// SITUACOES_TERMINAIS_IDS do back (enums.ts) e o do Raptor.
export const SITUACOES_TERMINAIS_IDS = [
  SituacaoChamado.Encerrado,
  SituacaoChamado.Cancelado,
];

export const situacaoEhTerminal = (situacaoId) =>
  SITUACOES_TERMINAIS_IDS.includes(situacaoId);

// Fallback usado só enquanto a lista real não chega, ou se a requisição falhar — ver
// services/situacoes.js. Não é fonte da verdade: a tabela é.
export const SITUACOES_FALLBACK = [
  { id: SituacaoChamado.Em_Aberto, descricao: "Em Aberto" },
  { id: SituacaoChamado.Em_Analise, descricao: "Em Análise" },
  { id: SituacaoChamado.Elaborando_Orcamento, descricao: "Elaborando Orçamento" },
  { id: SituacaoChamado.Aguardando_Aprovacao, descricao: "Aguardando Aprovação" },
  { id: SituacaoChamado.Em_Progresso, descricao: "Em Progresso" },
  { id: SituacaoChamado.Encerrado, descricao: "Encerrado" },
  { id: SituacaoChamado.Cancelado, descricao: "Cancelado" },
];

export const TipoAcaoChamado = {
  Texto: 0,
  Anexo: 1,
};
export const DescEnum_TipoAcaoChamado = {
  [TipoAcaoChamado.Texto]: "Texto",
  [TipoAcaoChamado.Anexo]: "Anexo",
};

export const AcaoDe = {
  Cliente: 0,
  Customax: 1,
};
export const DescEnum_AcaoDe = {
  [AcaoDe.Cliente]: "Cliente",
  [AcaoDe.Customax]: "Customax",
};

export const TipoServicoChamado = {
  Duvida: 1,
  Erro: 2,
  Servico: 3,
};
export const DescEnum_TipoServicoChamado = {
  [TipoServicoChamado.Duvida]: "Dúvida",
  [TipoServicoChamado.Erro]: "Erro",
  [TipoServicoChamado.Servico]: "Serviço",
};

export const UrgenciaChamado = {
  Alta: 1,
  Media: 2,
  Baixa: 3,
};
export const DescEnum_UrgenciaChamado = {
  [UrgenciaChamado.Alta]: "Alta",
  [UrgenciaChamado.Media]: "Média",
  [UrgenciaChamado.Baixa]: "Serviço",
};

export const AreaChamado = {
  Comercial: 1,
  Financeiro: 2,
  Industrial: 3,
  Controladoria: 4,
};
export const DescEnum_AreaChamado = {
  [AreaChamado.Comercial]: "Comercial",
  [AreaChamado.Financeiro]: "Financeiro",
  [AreaChamado.Industrial]: "Industrial",
  [AreaChamado.Controladoria]: "Controladoria",
};

// TipoNoticia (Texto/Imagem) removido em 2026-09-15: a notícia do Portal passou a ser só imagem.

export const OutroEnum = {
  Valor1: "valor1",
  Valor2: "valor2",
};

export const convertToArray = (object, descEnumObj) => {
  return Object.keys(object).map((key) => descEnumObj[object[key]]);
};

export function mapToIds(enumObj, descEnumObj, arrayOfStrings) {
  return arrayOfStrings.map((status) => {
    const key = Object.keys(enumObj).find(
      (key) => descEnumObj[enumObj[key]] === status
    );
    return enumObj[key];
  });
}

export const getOptionsFromEnum = (enumObj, descObj) => {
  return Object.keys(enumObj).map((key) => ({
    label: descObj[enumObj[key]],
    value: enumObj[key],
  }));
};
